import { defineStore, acceptHMRUpdate } from 'pinia';
import utilitiesData from '../../utilities/common/data';
import typeDestinationRepository from '../../repositories/master-data/typeDestinationRepository';

const dataTypeDestination = {
  dest_name: null,
};

export const useDestinationTypeStore = defineStore('destinationTypeStore', {
  state: () => ({
    componentKey: 0,
    isSuccess: false,
    hasErrorSingle: null,
    // list page
    perpage: 20,
    search: null,
    page: 1,
    listData: [],
    pagination: {},
    isLoadingTable: false,
    // form page
    formData: structuredClone(dataTypeDestination),
    hasFormError: structuredClone(dataTypeDestination),
    isLoadingForm: false,
  }),
  actions: {
    async getData() {
      try {
        this.isLoadingTable = true;
        this.hasErrorSingle = null;
        this.isSuccess = false;

        const params = {
          search: this.search,
          page: this.page,
          perpage: this.perpage,
        };
        const dataTypeDestination = await typeDestinationRepository.getData(params);
        if (dataTypeDestination.data.status === 200) {
          this.listData = dataTypeDestination.data.data.destination_type.list;
          this.pagination = dataTypeDestination.data.data.destination_type.pagination;
          this.isLoadingTable = false;
          this.componentKey++;
          this.isSuccess = true;
        }
      } catch (error) {
        console.log(error);
        this.isLoadingTable = false;
        this.isSuccess = false;
      }
    },
    async searchData() {
      this.page = 1;
      await this.getData();
    },
    async getDataByPaging() {
      await this.getData();
    },
    async saveData() {
      try {
        this.isLoadingForm = true;
        this.isSuccess = false;
        this.resetForm(false, false);

        const params = this.formData;
        const saveTypeDestination = await typeDestinationRepository.saveData(params);
        if (saveTypeDestination.data.status === 200) {
          this.isSuccess = true;
          this.resetForm();
        }
      } catch (error) {
        console.log(error);
        this.setFormError(error.response.data.error);
        this.isSuccess = false;
        this.isLoadingForm = false;
      }
    },
    async getDataDetail(id) {
      this.isSuccess = false;

      const params = {
        dest_type_id: id,
      };
      const dataDetailTypeDestination = await typeDestinationRepository.getDataDetail(params);

      if (dataDetailTypeDestination.data.status === 200) {
        this.isSuccess = true;
        const data = dataDetailTypeDestination.data.data;
        this.formData = {
          dest_name: data.name,
        };
      }
    },
    async updateData(id) {
      try {
        this.isSuccess = false;
        this.isLoadingForm = true;
        this.resetForm(false, false);

        const params = {
          dest_type_id: id,
          ...this.formData,
        };
        const updateTypeDestination = await typeDestinationRepository.updateData(params);
        if (updateTypeDestination.data.status === 200) {
          this.isSuccess = true;
          this.resetForm();
        }
      } catch (error) {
        console.log(error);
        this.setFormError(error.response.data.error);
        this.isSuccess = false;
        this.isLoadingForm = false;
      }
    },
    async deleteData(id) {
      try {
        this.isSuccess = false;

        const params = {
          dest_type_id: id,
        };
        const deleteTypeDestination = await typeDestinationRepository.deleteData(params);
        if (deleteTypeDestination.data.status === 200) {
          this.isSuccess = true;
        }
      } catch (error) {
        console.log(error);
        this.isSuccess = false;
      }
    },
    setFormError(error) {
      if (typeof error === 'string' || error instanceof String) {
        this.hasErrorSingle = error;
      } else {
        Object.keys(error).forEach((item) => {
          this.hasFormError[item] = error[item][0];
        });
      }
    },
    resetForm(withContent = true, withLoading = true) {
      if (withContent) {
        this.formData = structuredClone(dataTypeDestination);
      }
      this.hasFormError = structuredClone(dataTypeDestination);
      this.hasErrorSingle = null;
      if (withLoading) {
        this.isLoadingForm = false;
      }
    },
    removeErrorFormSingle(key) {
      this.hasFormError[key] = null;
    },
  },
  getters: {},
});

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept(acceptHMRUpdate(useDestinationTypeStore, import.meta.webpackHot));
}
